import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useWallet } from '@/store/modules/wallet/useWallet';
import { useLocalStorage } from '@/composables/useLocalStorage';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { switchNetwork } from '@/utils/blockchain';
import { fixOverlayPosition } from '@/composables/utils/useUtils';
import {
  getNetworkParams,
  getNetworkId,
  APP_NETWORK_NAME,
  SELECTED_NETWORK_NAME,
} from '@/helpers/networkParams.helper';
import { getUrlWithoutParam, updatePageUrl } from '@/helpers/appParams.helper';
import { SUPPORTED_NETWORK_MODE } from '@/constants/SUPPORTED_NETWORK_MODE';
import { HEADER_HEIGHT } from '@/constants/LAYOUT_PARAMS';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { isWrappedNetwork } from '@/helpers/network-methods.helper';
import { NETWORK_VALUE_BY_WRAPPED_NETWORK_VALUE } from '@/constants/NETWORK_NAMES';
import { NETWORK_OPTIONS, Network } from '@/constants/NETWORK_OPTIONS';


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkSelect',
  props: {
    currentNetwork: null
  },
  setup(__props: any) {

const props = __props as {
  currentNetwork: string;
}



const { state } = useStore();
const { walletState, disconnect } = useWallet();

const netsDropdown = ref();

const appNetwork = ref(props.currentNetwork);
const selectedNetwork = computed(() => NETWORK_VALUE_BY_WRAPPED_NETWORK_VALUE[appNetwork.value]);

const isPreventHidingDropdown = ref(false);

const setNewNetworkInfo = () => {
  useLocalStorage().setItem(`network_${SUPPORTED_NETWORK_MODE}`, appNetwork.value);
};

const onHide = () => {
  if (isPreventHidingDropdown.value) {
    netsDropdown.value.show();
  }
};

const onSwitchNetwork = async event => {
  const selectedNetId = getNetworkId(event.value);
  const currentNetId = walletState.wallets[SELECTED_NETWORK_NAME]?.chainId;

  if (ENABLE_FAKE_CARDANO_NETWORK || isWrappedNetwork(event.value)) {
    setNewNetworkInfo();
    disconnect();
    return;
  }

  if (!walletState.isInjected || selectedNetId == currentNetId) {
    setNewNetworkInfo();
    updatePageUrl(getUrlWithoutParam('network'));
    return;
  }

  isPreventHidingDropdown.value = true;

  console.log(`[SWITCH:CHAIN] Switch to '${selectedNetId}' chain id.`);
  const net = getNetworkParams(selectedNetId);

  try {
    setNewNetworkInfo();
    await switchNetwork(net);
    // Code here may be executed or may not be,
    // because `chainChanged` event can be handler early.
  } catch (error) {
    appNetwork.value = APP_NETWORK_NAME;
    setNewNetworkInfo();
    console.error('Canceled', error);
  } finally {
    isPreventHidingDropdown.value = false;
  }
};

const fixPosition = () => {
  if (!state.layout.isMobile) fixOverlayPosition('.network-select', HEADER_HEIGHT);
};

const getName = value => NETWORK_OPTIONS.find(item => item.value === value)?.name;
const getIconPath = name => `/images/tokens/${name.toLowerCase()}.svg`;

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    ref_key: "netsDropdown",
    ref: netsDropdown,
    modelValue: appNetwork.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appNetwork).value = $event)),
    options: _unref(NETWORK_OPTIONS) as Network[],
    "option-label": "name",
    "option-value": "value",
    class: "w-full dropdown-button sm:w-14rem",
    "panel-class": "dropdown-list network-select",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (onSwitchNetwork($event))),
    onHide: onHide,
    onShow: fixPosition
  }, {
    value: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TokenIcon, {
          "icon-src": getIconPath(_unref(selectedNetwork)),
          class: "mr-s1",
          size: "20"
        }, null, 8, ["icon-src"]),
        _createTextVNode(" " + _toDisplayString(getName(slotProps.value)), 1)
      ])
    ]),
    option: _withCtx((slotProps) => [
      _createVNode(TokenIcon, {
        "icon-src": getIconPath(_unref(NETWORK_VALUE_BY_WRAPPED_NETWORK_VALUE)[slotProps.option.value]),
        class: "mr-s1",
        size: "20"
      }, null, 8, ["icon-src"]),
      _createTextVNode(" " + _toDisplayString(slotProps.option.name), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}
}

})